import { LegendControl } from '@/ui/legend-control/legend-control';
import { PlaceMarkerPin } from '../place-marker-pin';
import { ClusterSymbol } from '../places-layer/components/cluster-symbol';
import classes from './legend.module.css';

export function Legend() {
  return (
    <LegendControl>
      <div>
        <ClusterSymbol size={24} label="#" />
      </div>
      <div>Ports in Region</div>
      <div className={classes.pin}>
        <PlaceMarkerPin />
      </div>
      <div>Port</div>
    </LegendControl>
  );
}
